
import { mapActions, mapState } from "vuex";
import { BUSINESS_OUTLET_CREATED } from "@/constants/MixpanelEvents.js";
import ResponsiveDialog from "./responsive-dialog.vue";

export default {
  name: "AddNewBrandDialog",
  components: { ResponsiveDialog },

  props: {
    dialog: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState("restaurant", ["locationDetails"]),
    isFormValid() {
      const enabledChannels = this.selectedChannels.filter(
        (item) => item.isEnabled
      );
      if (!enabledChannels.length) {
        return false;
      }
      for (let i = 0; i < enabledChannels.length; i++) {
        const obj = enabledChannels[i];
        if (!obj.loginId || !this.isURL(obj.url)) {
          return false;
        }
      }
      return true;
    }
  },
  data() {
    return {
      valid: false,
      brandName: "",
      selectAll: true,
      selectedChannels: [],
      loading: false
    };
  },
  beforeMount() {
    this.selectedChannels = this.$constants.Channels.CHANNELS.map((element) => {
      return {
        name: element.name,
        loginId: "",
        url: "",
        isEnabled: true
      };
    });
  },
  methods: {
    ...mapActions("restaurant", ["createBrand"]),
    async handleSubmit() {
      this.loading = true;
      let restaurant = { name: this.brandName };
      restaurant.restaurant_platforms = this.selectedChannels
        .filter((el) => el.isEnabled)
        .map((el) => {
          return {
            name: el.name,
            login_id: el.loginId,
            url: el.url
          };
        });

      try {
        const { data } = await this.createBrand({
          restaurant,
          id: this.locationDetails.id
        });
        this.mixPanelTrackEvent(BUSINESS_OUTLET_CREATED);
        this.$nuxt.$emit("show-toast", {
          text: "New outlet added successfully",
          color: "success darken-2",
          icon: "done",
          flat: true
        });
        this.$emit("close-dialog");
      } catch (err) {
        this.$nuxt.$emit("show-error-toast", err);
      }
      this.loading = false;
    },
    handleSelectAllChange() {
      for (let index = 0; index < this.selectedChannels.length; index++) {
        this.selectedChannels[index].isEnabled = this.selectAll;
      }
    },
    handleChannelChange() {
      this.selectAll = !this.selectedChannels.find((item) => !item.isEnabled);
    }
  }
};
